webpackJsonp([265325084265088],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Container = __webpack_require__(8);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Header = __webpack_require__(36);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _TitleAndMetaTags = __webpack_require__(21);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _siteConstants = __webpack_require__(37);
	
	var _theme = __webpack_require__(4);
	
	var _toCommaSeparatedList = __webpack_require__(122);
	
	var _toCommaSeparatedList2 = _interopRequireDefault(_toCommaSeparatedList);
	
	var _MetaTitle = __webpack_require__(56);
	
	var _MetaTitle2 = _interopRequireDefault(_MetaTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllBlogPosts = function AllBlogPosts(_ref) {
	  var data = _ref.data;
	  return Glamor.createElement(
	    _Container2.default,
	    null,
	    Glamor.createElement(
	      'div',
	      { css: _theme.sharedStyles.articleLayout.container },
	      Glamor.createElement(
	        'div',
	        { css: _theme.sharedStyles.articleLayout.content },
	        Glamor.createElement(
	          _Header2.default,
	          null,
	          'All Posts'
	        ),
	        Glamor.createElement(_TitleAndMetaTags2.default, {
	          ogUrl: _siteConstants.urlRoot + '/blog/all.html',
	          title: 'React - All Posts'
	        }),
	        Glamor.createElement(
	          'ul',
	          {
	            css: {
	              display: 'flex',
	              flexWrap: 'wrap',
	              marginLeft: -40
	            } },
	          data.allMarkdownRemark.edges.map(function (_ref2) {
	            var _ref3;
	
	            var node = _ref2.node;
	            return Glamor.createElement(
	              'li',
	              {
	                css: (_ref3 = {
	                  paddingLeft: 40,
	                  paddingTop: 40,
	                  borderTop: '1px dotted #ececec',
	                  paddingBottom: 40,
	                  width: '100%'
	
	                }, _ref3[_theme.media.size('medium')] = {
	                  width: '50%'
	                }, _ref3[_theme.media.greaterThan('large')] = {
	                  width: '33.33%'
	                }, _ref3),
	                key: node.fields.slug },
	              Glamor.createElement(
	                'h2',
	                {
	                  css: {
	                    fontSize: 24,
	                    color: _theme.colors.dark,
	                    lineHeight: 1.3,
	                    fontWeight: 700
	                  } },
	                Glamor.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    css: {
	                      borderBottom: '1px solid #ececec',
	                      ':hover': {
	                        borderBottomColor: _theme.colors.black
	                      }
	                    },
	                    key: node.fields.slug,
	                    to: node.fields.slug },
	                  node.frontmatter.title
	                )
	              ),
	              Glamor.createElement(
	                _MetaTitle2.default,
	                null,
	                node.fields.date
	              ),
	              node.frontmatter.author ? Glamor.createElement(
	                'div',
	                {
	                  css: {
	                    color: _theme.colors.subtle,
	                    marginTop: -5
	                  } },
	                'by',
	                ' ',
	                (0, _toCommaSeparatedList2.default)(node.frontmatter.author, function (author) {
	                  return Glamor.createElement(
	                    'span',
	                    { key: author.frontmatter.name },
	                    author.frontmatter.name
	                  );
	                })
	              ) : null
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	// eslint-disable-next-line no-undef
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = AllBlogPosts;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-all-html-js-04f63d708f2d0955c0f5.js